import { Container, Row, Col, Card, CardBody, CardText } from "reactstrap";
import { useParams } from 'react-router-dom';
import 'react-phone-number-input/style.css'
import QRCode from 'react-qr-code';

export default function Ticket() {
  const { code_reg } = useParams();

  return (
        <section className="section bg-detail" id="home">
            <Container>
                <Row>
                    <Col lg='12' style={{marginTop: '100px'}}>
                        <Card className="ticket-card d-flex justify-content-center align-items-center p-4">
                            <CardBody>
                                <CardText>
                                    <h3 className="text-center">This is your ticket code:</h3>
                                    <h1 className="text-center ticket-code">{code_reg}</h1>
                                    <p className="text-center mb-3">Please save this code for event check-in.</p>
                                    <QRCode value={code_reg} size={256} />
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
